import {
  EditOutlined,
  ExclamationCircleFilled,
  MinusOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';
import { EnhancedBillingPage } from '@mm/state/interfaces/connected-page';
import { SubscriptionModel } from '@mm/state/model/SubscriptionModel';
import { selectIsShopifyContext } from '@mm/state/selectors/viewSelectors';
import { centsToDollars } from '@mm/utils';
import { Tooltip } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import styles from './BudgetCap.module.css';
import { useBudgetCap } from './use-budget-cap';

export const BudgetCap = ({
  subscription,
  retrieveSubscription,
  page,
}: {
  subscription: SubscriptionModel;
  retrieveSubscription: () => void;
  page: EnhancedBillingPage;
}) => {
  const isShopify = useSelector(selectIsShopifyContext);

  const capValue = subscription.budgetCap
    ? `$${centsToDollars(subscription.budgetCap)}/${
        subscription.billingPeriodLength === 'monthly' ? 'mo' : 'year'
      }`
    : 'No Limit';

  const onUpdateSuccess = () => {
    retrieveSubscription?.();
  };

  const { updateBudgetCap } = useBudgetCap({
    subscription,
    onSuccess: onUpdateSuccess,
  });

  if (isShopify) {
    return null;
  }

  return (
    <div className={styles.budgetCap}>
      <div
        className={classNames({
          [styles.budgetCapTitle]: page.budgetCapReachedAt,
        })}
      >
        {page.budgetCapReachedAt && (
          <ExclamationCircleFilled className={styles.exclamationIcon} />
        )}
        Budget Cap <MinusOutlined /> {capValue}
      </div>
      <EditOutlined onClick={updateBudgetCap} />
      <Tooltip title="The account is managed by an approximate cap. Actual usage may slightly exceed the limit.">
        <QuestionCircleOutlined style={{ marginLeft: 16 }} />
      </Tooltip>
    </div>
  );
};
